<ps-ui-survey-unicorns-info
  [unicornQuotas]="unicornQuotas"
  *ngIf="shouldShowUnicornQuotaHeader()"
></ps-ui-survey-unicorns-info>

<ps-ui-survey-difficult-quotas-info
  [impossibleQuotas]="!!unicornQuotas.length"
  [difficultQuotas]="difficultQuotas"
  *ngIf="shouldShowUnicornDifficultQuotaHeader()"
>
</ps-ui-survey-difficult-quotas-info>
